export default __webpack_public_path__ + "static/media/select-radio-active.3ba90d3d.svg";